module.exports = __webpack_public_path__ + "static/img/son4_active.a04cc62d.png";